import { nanoid } from 'nanoid';
import { useDashboardStore } from '@/stores/useDashboardStore';
import { useHead } from '#app';

const SESSION_STORAGE_KEY = 'beaconToken';

/**
 * Composable for managing a unique user session ID.
 * The ID is persisted in sessionStorage.
 */
export const useUserSessionId = () => {
  const dashboardStore = useDashboardStore();

  const postToRiskified = (sessionId) => {
    const session_id = sessionId;
    const url =
      ('https:' == document.location.protocol ? 'https://' : 'http://') + 'beacon.riskified.com?shop=' + window.location.host + '&sid=' + session_id;
    useHead({
      script: [
        {
          src: url,
          async: true,
        },
      ],
    });
  };

  /**
   * Retrieves the session ID from sessionStorage.
   * @returns {string | null} The session ID or null if not set.
   */
  const getId = () => sessionStorage.getItem(SESSION_STORAGE_KEY);

  /**
   * Generates and stores a new session ID.
   * @returns {string} The newly created session ID.
   */
  const setId = () => {
    const id = nanoid();
    sessionStorage.setItem(SESSION_STORAGE_KEY, id);
    return id;
  };

  /**
   * Initializes the session ID if it doesn't exist.
   * @returns {string} The existing or newly created session ID.
   */
  const userSessionIdInit = () => {
    if (import.meta.client && dashboardStore.killswitches?.preTransactionRiskAdviseEnabled) {
      const sessionId = getId() || setId();
      postToRiskified(sessionId);
    }
  };

  return { getId, setId, userSessionIdInit, postToRiskified };
};

export default useUserSessionId;
